// Generated by purs version 0.15.15
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Services_FFI_TaskEither from "../Ouroboros.Services.FFI.TaskEither/index.js";
var createStubOrganizationSignupClient = {
    signup: function (v) {
        return Ouroboros_Services_FFI_TaskEither.right(Ouroboros_Models_Core_Ok.ok);
    }
};
export {
    createStubOrganizationSignupClient
};
//# sourceMappingURL=index.js.map
